module.exports = __webpack_public_path__ + "img/login-v2-dark.aa5e43c0.svg";